import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';

import type React from 'react';
import styles from './index.module.scss';

import { HIGHLIGHT_WORDS_FOR_QUESTION } from '@/constant';
import { highlightText } from '@/utils/highlighter';
import { safeHtml } from '@/utils/safeHtml';
import CorrectIcon from './-assets/icon_correct.svg';
import FailedIcon from './-assets/icon_failed.svg';

export const USER_SKILL_CHECK_TEST_ANSWER = graphql(/* GraphQL */ `
  fragment EmbaUserSkillCheckTestAnswer on UserSkillCheckTestAnswer {
    id
    isCorrect
    embaCourseSkillCheckTestQuestion{
      id
      ordinal
      content
      questionType
      attachmentImage
      choices{
        id
        content
      }
    }
    choices{
      id
      embaCourseSkillCheckTestQuestionChoice{
        id
        content
        ordinal
      }
    }
  }
`);

export type AnswerListItemProps = {
  answer: FragmentType<typeof USER_SKILL_CHECK_TEST_ANSWER>;
};

export const AnswerListItem: React.FC<AnswerListItemProps> = ({ answer }) => {
  const answerData = useFragment(USER_SKILL_CHECK_TEST_ANSWER, answer);

  return (
    <li key={answerData.id} className={styles.question}>
      <div className={styles.questionLabelArea}>
        <p className={styles.questionLabel}>
          問{answerData.embaCourseSkillCheckTestQuestion.ordinal}
        </p>
        <p className={styles.resultText}>
          {answerData.isCorrect ? (
            <>
              <span>正解！</span>
              <img src={CorrectIcon} alt="" />
            </>
          ) : (
            <>
              <span>不正解</span>

              <img src={FailedIcon} alt="" />
            </>
          )}
        </p>
      </div>

      <p
        className={styles.questionContent}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: サニタイズ済みのHTMLを表示するため
        dangerouslySetInnerHTML={{
          __html: safeHtml(
            highlightText(
              answerData.embaCourseSkillCheckTestQuestion.content,
              HIGHLIGHT_WORDS_FOR_QUESTION,
            ),
          ),
        }}
      />

      <ul className={styles.questionChoices}>
        {answerData.embaCourseSkillCheckTestQuestion.choices.map((choice) => (
          <li key={choice.id} className={styles.questionChoice}>
            {answerData.embaCourseSkillCheckTestQuestion.questionType ===
            'single_choice' ? (
              <input
                type="radio"
                id={choice.id}
                value={choice.id}
                name={`question-${answerData.embaCourseSkillCheckTestQuestion.id}`}
                checked={
                  answerData.choices[0].embaCourseSkillCheckTestQuestionChoice
                    .id === choice.id
                }
                onChange={() => {}}
              />
            ) : (
              <input
                type="checkbox"
                id={choice.id}
                name={`question-${answerData.embaCourseSkillCheckTestQuestion.id}`}
                value={choice.id}
                checked={answerData.choices.some(
                  (questionChoice) =>
                    questionChoice.embaCourseSkillCheckTestQuestionChoice.id ===
                    choice.id,
                )}
                onChange={() => {}}
              />
            )}
            <label className={styles.questionChoiceLabel} htmlFor={choice.id}>
              {choice.content}
            </label>
          </li>
        ))}
      </ul>
    </li>
  );
};
